<template>
  <div>
    <div>
      <switches v-model="item.enabled" theme="bootstrap" color="success" type-bold="true"
              :text-enabled="text_enabled" :text-disabled="text_disabled"></switches>
    </div><br>
    <div @click="toggleDiv(index)" style="width: 150px; cursor: pointer;">
      <small>Enter alternative amount?</small>
    </div>
    <div :id="`input_${index}`" ref="cells" contenteditable="true" style="display:none;"
           class="div-input" @focusin="clearDivError(index)"
           @focusout="getNewDivDataForTableForm(index)">{{ approved_amount }} </div>

  </div>
</template>

<script>
import Switches from 'vue-switches';
import EventBus from "@/components/EventBus";
import {clearDivError, getNewDivDataForTableForm} from "@/utils/util_functions";

export default {
  name: "ApprovedAmountSwitch",
  components: {Switches},

  data(){
    return{
      approved_amount:0,
      text_enabled: "Approved",
      text_disabled: "Declined",
      unauthorized_text:'',
    }
  },

  props: {
    index: {
      required: true
    },

    item: {
      required: true,
    }
  },
  mounted() {
    EventBus.$on('unauthorized-access', payload =>{
      this.unauthorized_text = payload
    })
  },

  methods: {
    getNewDivDataForTableForm, clearDivError,
    toggleDiv(index){
      let div = document.getElementById('input_'+index)
      if (div.style.display === "none") {
        div.style.display = "block";
        // enable the switch
        this.item.enabled = true
      } else {
        div.style.display = "none";
        // disable the switch
        this.item.enabled = false
      }
    },
  }
}
</script>
